<template>
    <div>
        <entity-overview entity-type="MessageTemplate"></entity-overview>
    </div>
</template>
<style scoped>
</style>
<script>
    function initialState() {
        return {
            saving: false,
            loading: false,
            body: ''
        };
    }
    export default {
        name: "SettingsMessageTemplatesView",
        data: function () {
            return initialState();
        },
        mounted: function () {
        },
        props: {
        },
        methods: {
            reset: function () {
                Object.assign(this.$data, initialState());
            },
        },
        computed: {
        }
    };
</script>